<template>
  <nav class="breadcrumb is-large" aria-label="breadcrumbs">
    <ul>
      <li
        v-for="link in links"
        :key="link.routeName"
        :class="{ 'is-active': link.isActive }"
      >
        <router-link
          :to="{ name: link.routeName }"
          :aria-current="isCurrentAria(link.isActive)"
        >
          <span>
            <ViewDashboard v-if="link.icon === 'dashboard'" />
            <TrophyVariantOutline v-if="link.icon === 'trophy'" />
            <History v-if="link.icon === 'history'" />
            <FormatListBulletedSquare v-if="link.icon === 'list'" />
            <AccountMultiple v-if="link.icon === 'account'" />
            <VideoOutline v-if="link.icon === 'video'" />
            &nbsp;
          </span>
          <span>{{ link.label }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import ViewDashboard from 'vue-material-design-icons/ViewDashboard.vue'
import TrophyVariantOutline from 'vue-material-design-icons/TrophyVariantOutline.vue'
import History from 'vue-material-design-icons/History.vue'
import FormatListBulletedSquare from 'vue-material-design-icons/FormatListBulletedSquare.vue'
import AccountMultiple from 'vue-material-design-icons/AccountMultiple.vue'
import VideoOutline from 'vue-material-design-icons/VideoOutline.vue'

export default {
  name: 'Breadcrumbs',
  components: {
    ViewDashboard,
    TrophyVariantOutline,
    History,
    FormatListBulletedSquare,
    AccountMultiple,
    VideoOutline
  },
  props: {
    links: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    isCurrentAria (isActive) {
      return isActive ? 'page' : false
    }
  }
}
</script>

<style>
  .breadcrumb{
    margin-top: 1.5rem;
  }
</style>
